// import React from 'react'

import * as React from "react"
import { Outlet } from "react-router-dom"

function FramelessLayout({children}: {children?: React.ReactNode}) {
    return <Outlet/>;
}

export default FramelessLayout
